import { Component, input, output } from '@angular/core';
import { CharityRowData } from '../charity-row/charity-row.component';

/**
 * Charity Explorer component that displays a list of featured charities
 * Figma: https://www.figma.com/design/W3VBXvQM2bo98mSNlDSzhi/GivingSpace-Reimagining?node-id=1058-36083
 */
@Component({
  selector: 'app-charity-explorer',
  standalone: false,
  templateUrl: './charity-explorer.component.html',
  styleUrls: ['./charity-explorer.component.scss']
})
export class CharityExplorerComponent {
  /**
   * Array of charity data to display
   */
  charities = input.required<CharityRowData[]>();

  /**
   * Translation key for the title
   */
  titleKey = input<string>('charity_explorer.title');

  /**
   * Translation key for the subtitle
   */
  subtitleKey = input<string>('charity_explorer.subtitle');

  /**
   * Translation key for the "Browse All" link text
   */
  browseAllTextKey = input<string>('charity_explorer.browse_all');

  /**
   * URL for the "Browse All" link
   */
  browseAllUrl = input<string>('#');

  /**
   * Whether to show the "Browse All" link
   */
  showBrowseAll = input<boolean>(true);

  /**
   * Maximum number of charities to display
   */
  maxVisible = input<number>(5);

  /**
   * Background color of the content card
   */
  backgroundColor = input<string | undefined>('#F3F3F352');

  /**
   * Event emitted when the "Browse All" link is clicked
   */
  browseAllClicked = output<void>();

  /**
   * Event emitted when a charity row is clicked
   */
  charityClicked = output<CharityRowData>();

  /**
   * Event emitted when the Give button on a charity row is clicked
   */
  giveClicked = output<CharityRowData>();

  /**
   * Gets the visible charities based on maxVisible limit
   */
  getVisibleCharities(): CharityRowData[] {
    const max = this.maxVisible();
    const allCharities = this.charities();
    return max > 0 ? allCharities.slice(0, max) : allCharities;
  }

  /**
   * Handles the "Browse All" link click
   */
  onBrowseAllClick(): void {
    this.browseAllClicked.emit();
  }

  /**
   * Handles a charity row click
   */
  onCharityClick(charity: CharityRowData): void {
    this.charityClicked.emit(charity);
  }

  /**
   * Handles the Give button click on a charity row
   */
  onGiveClick(charity: CharityRowData): void {
    this.giveClicked.emit(charity);
  }
}
